export class ProgressMetric {
    constructor(params) {
        this.name = params.name;
        this.current = params.current;
        this.expected = params.expected;
        this.unit = params.unit;
    }
}
